import { useMemo } from "react";
import { useAxiosGet } from "../../../infrastructure/http";
import { ListEdiTrackingOutstandingInvoicesResponse } from "../../../common/EdiTrackingOutstandingInvoiceItem";

export function useEdiTrackingOutstandingInvoices(locationId: number) {
	return useAxiosGet<ListEdiTrackingOutstandingInvoicesResponse>(
		useMemo(
			() => ({
				url: "ediTrackingOutstandingInvoices",
				params: { locationId },
			}),
			[locationId]
		),
		false,
		false
	);
}